import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4InputSubmitEventProps extends GA4GeneralProps {
  featureClass?: string | null
  featureName?: string | null
  inputMethod: string
  successfulAttempt: boolean
  selectedOption?: string | null
}

export class GA4InputSubmitEvent extends GA4Event {
  ga4_feature_class: GA4InputSubmitEventProps['featureClass']
  ga4_feature_name: GA4InputSubmitEventProps['featureName']
  ga4_input_method: GA4InputSubmitEventProps['inputMethod']
  ga4_successful_attempt: GA4InputSubmitEventProps['successfulAttempt']
  ga4_selected_option: GA4InputSubmitEventProps['selectedOption']

  constructor({
    featureClass = null,
    featureName = null,
    inputMethod,
    successfulAttempt,
    selectedOption = null,
    ...generalProps
  }: GA4InputSubmitEventProps) {
    super({ event: EVENT.INPUT_SUBMIT, ...generalProps })

    this.ga4_feature_class = featureClass
    this.ga4_feature_name = featureName
    this.ga4_input_method = inputMethod
    this.ga4_successful_attempt = successfulAttempt
    this.ga4_selected_option = selectedOption
  }
}
